import modalExport from "@hg/modal"
import { noop } from "lodash"
import React, { useState } from "react"
import { Modal } from "../Modal"
import { sfxPlay } from "@/assets/audios/sfx"

export const showConfirm = ({
    content,
    onOk = noop,
    onCancel = noop,
}: {
    content: React.ReactNode
    onOk?: () => void
    onCancel?: () => void
}) => {
    sfxPlay("dialog")
    modalExport.show(
        ({ onClose }) => {
            const [open, setOpen] = useState(true)
            return (
                <div style={{ width: "100%", height: "100%" }}>
                    <Modal
                        open={open}
                        onConfirm={onOk}
                        onClose={() => {
                            setOpen(false)
                            onCancel?.()
                            onClose()
                        }}
                    >
                        {content}
                    </Modal>
                </div>
            )
        },
        {
            maskClassName: "modal-mask",
        }
    )
}
